import { all } from 'redux-saga/effects'
import {getDataAsync} from './sagas';

// we now only export the rootSaga
// single entry point to start all Sagas at once
export default function* rootSaga() {
  yield all([
    getDataAsync(),
    // ...
  ])
}
